const createBalancesAnalyticsPlugin = ({
  analytics,
  hasBalanceAtom,
  assetsWithBalanceCountAtom,
}) => {
  let subscriptions = []

  const onStart = () => {
    analytics.requireDefaultEventProperties(['hasBalance', 'numberOfAssets'])

    const unsubscribeBalanceAtom = hasBalanceAtom.observe((hasBalance) =>
      analytics.setDefaultEventProperties({ hasBalance })
    )

    const unsubscribeBalanceCountAtom = assetsWithBalanceCountAtom.observe((numberOfAssets) =>
      analytics.setDefaultEventProperties({ numberOfAssets })
    )

    subscriptions = [unsubscribeBalanceAtom, unsubscribeBalanceCountAtom]
  }

  const onStop = () => {
    subscriptions.forEach((unsubscribe) => unsubscribe())
  }

  return { onStart, onStop }
}

export default createBalancesAnalyticsPlugin
